module.exports = __webpack_public_path__ + "img/12.8fb1b7f5.png";